import { common } from './common';

export const en = {
  common,
};